import Button from 'components/Buttons/CommonButton';
import { useTheme } from 'providers/ThemeProvider';
import React from 'react';
import styled from 'styled-components/macro';
import intlHelper from 'utils/helpers/intl.helper';
import Icon from 'components/Input/Icon';
import { colorPalette, colorPaletteDark } from 'utils/styleConstants';

const ToolbarWrapper = styled.div<{ width?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ width }) => (width ? `width: ${width}` : null)}
`;

const Results = styled.p`
  font-size: ${({ theme }) => theme.fontSizePalette.xxSmall};
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

interface Props {
  results: number;
  onRemoveFilters: any;
  hasFilters: number;
  hasExport?: boolean;
  onExportClick?: () => void;
  width?: string;
}

const Toolbar = (props: Props) => {
  const { results, onRemoveFilters, hasFilters, hasExport, onExportClick } = props;
  const t = intlHelper.useTranslator();
  const { isDarkMode } = useTheme();

  return (
    <ToolbarWrapper width={props.width}>
      <Results>{`${results} ${t('results')}`}</Results>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {hasExport ? (
          <Icon
            icon="file-csv"
            size="lg"
            onClick={onExportClick}
            style={{
              color: isDarkMode ? colorPaletteDark.turquoise.accent : colorPalette.turquoise.normal,
            }}
          />
        ) : null}
        <Button
          id="remove-filters-btn"
          customIcon="trash"
          value={t('removeFilters')}
          scope="tertiary"
          disabled={hasFilters === 0}
          action={onRemoveFilters}
        />
      </div>
    </ToolbarWrapper>
  );
};

export default Toolbar;
